import { FC, useState, MouseEvent, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  Grid, Typography, TextField, FormControlLabel,
  Checkbox, Box, Link, Button, Password, BottomLink
} from '../../../UI'
import useStyles from './styles'
import { validateEmail, history, isEmpty } from '../../../../helpers'
import { HashWrapper, AuthPage } from '../../../templates'
import LoaderPage from '../../Loader'
import { authActions } from '../../../../ducks/actions'
import ChangePassword from './ChangePassword'
import LinkIcon from '@material-ui/icons/Link'
import FlareIcon from '@material-ui/icons/Flare'

const Login: FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const push = history.usePush()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [remember, setRemember] = useState(true)

  const [loading, setLoading] = useState(false)
  const [wrongPassword, setWrongPassword] = useState(false)
  const [loginError, setLoginError] = useState(false)
  const [submit, setSubmit] = useState(false)
  const [openChange, setOpenChange] = useState(false)
  const [loginErrorMsg, setLoginErrorMsg] = useState('')

  const handleSubmit = (event: MouseEvent): void => {
    // event.preventDefault()
    setWrongPassword(false)
    setSubmit(true)
    setLoginError(false)

    if (validateEmail(email) && !isEmpty(password)) {
      setLoading(true)
      dispatch(authActions.loginRequest({
        email,
        password,
        remember,
        callback: (success, error) => {
          setLoading(false)
          if (!success) {
            if (error) {
              setLoginErrorMsg(error)
            }
            // if(error?.response?.status === 429)
            setLoginError(true)
            setWrongPassword(true)
          }
        }
      }))
    }

  }

  const handleEmailLogin = (event: MouseEvent): void => {
    event.preventDefault()

    push('login-email')
  }

  return (
    <HashWrapper error={loginError} setError={setLoginError}>
      <LoaderPage loading={loading}>
        <AuthPage center>
          <Typography variant='h6' className={classes.title}>
            Sign in
          </Typography>
          <form className={classes.form}>
            <TextField
              label='E-mail'
              type='email'
              variant='outlined'
              size='small'
              name='email'
              margin='normal'
              onDoubleClick={(event: any) => {
                event.target.select()
              }}
              value={email}
              className={classes.email}
              error={loginError || (submit && (isEmpty(email) || !validateEmail(email)))}
              helperText={submit && (isEmpty(email) || !validateEmail(email)) && 'Write your e-mail to sign-in'}
              onChange={(event) => setEmail(event.target.value)}
              fullWidth
            />
            <Password
              value={password}
              error={wrongPassword}
              helperText={submit && (
                (isEmpty(password) && 'Write your password to sign-in') ||
                (wrongPassword && 'Hey! Wrong email or password. Check it or write it again'))}
              onChange={(event) => {
                setWrongPassword(false)
                setPassword(event.target.value)
              }}
            />
            <Grid container className={classes.grid}>
              <Grid item xs>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={remember}
                      onChange={() => setRemember(!remember)}
                      name='remember' color='primary'
                    />
                  }
                  label={<Typography variant='body2'>Remember me</Typography>}
                />
              </Grid>
              <Grid item>
                {openChange && (
                  <ChangePassword
                    open={openChange}
                    setOpen={setOpenChange}
                    email={validateEmail(email) ? email : ''}
                  />
                )}
                <Link
                  href='#' variant='body2' onClick={
                    (event: React.SyntheticEvent) => {
                      event.preventDefault()
                      setOpenChange(true)
                    }
                  }
                > I forgot my password
                </Link>
              </Grid>
            </Grid>
            {loginError &&
              <Typography
                variant='body2'
                color='error'
                style={{
                  padding: '0 16px',
                  textAlign: 'center'
                }}
              >
                {loginErrorMsg ? loginErrorMsg : "An error occurred while trying to sign-in, please try again"}
              </Typography>}
            <Box py={1}>
              <Button
                type='button'
                variant='contained'
                color='primary'
                size='large'
                className={classes.submit}
                onClick={handleSubmit}
                fullWidth
              >
                SIGN-IN
              </Button>

              {/* <Button
                variant="outlined"
                size="large"
                color='primary'
                className={classes.emailLogin}
                onClick={handleEmailLogin}
                fullWidth
                endIcon={<LinkIcon className={classes.linkIcon} />}
              >
                Sign-in with Email
              </Button>

              <Grid container className={classes.linkDesc} alignItems='center' justifyContent='center'>
                <FlareIcon style={{ width: '14px', height: '14px' }} />
                <Typography align="center" style={{ fontSize: '14px' }}>
                  We’ll send a <b>link</b> for password-free sign in.
                </Typography>
              </Grid> */}

              <BottomLink
                question={'Don\'t have an account?'}
                linkText='Sign-up here'
                onClick={() => push('create')}
              />
            </Box>
          </form>
        </AuthPage>
      </LoaderPage>
    </HashWrapper>
  )
}

export default Login
